import { saveProfile } from '../actions/ProfileActions'
import { ajaxPutJSON } from '../AjaxUtil'

export const saveProfileResponse = saveProfile.flatMap((user) => ajaxPutJSON(`/rest/users/${user.id}`, user))
